import { atom } from 'nanostores';

export const openFeature = atom('location-by-number');
